/* eslint-disable no-useless-escape */
export const regexes = {
  alphabet: /^[a-z]+(([-']|\s)?[a-z]+)*$/i,
  alphabetSpecial: /^[a-z]+[!#%&'*+-/=?^_`{|}~]+(([-']|\s)?[a-z]+[!#%&'*+-/=?^_`{|}~]]+)*$/i,
  alphabetNumeric:
    /^((^[a-z]{2}\.\s)?((\w|\w')\s[a-z]{2}\.\s)?([a-z0-9]+-[a-z0-9]+)?(\/)?([a-z]{1}\'[a-z]+|\s[a-z]{1}\'[a-z]+|[a-z]\'\s[a-z]+|[a-z]\'[s]\s[a-z]+)*([a-z0-9]+\s{0,1})?)+(\w{2,}\'|[\w]|\w{2,}\'[s])$/i,
  email:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  numeric: /^[0-9]+$/,
  phone: /(01)\d{9}|(02)\d{9}|(07)\d{9}/,
  mobile: /^(07[\d]{9})$/,
  postCode:
    /^((GIR 0AA|X9 9RB|X9 9AA|X9 9BF|X9 9AJ|X9 9AB|X9 9TA|X9 9LG|X9 9BH|X9 9LF|X9 2TR|XE16 4QZ|XE11 1AA|XE98 1TL|XEP O11|XE99 3GG|XE0 2AQ|XE1A 1AA|XE18 3AN|XE7 4GJ|XE1P 2PR|XE2 7EJ|XE12 8JS|XE1H 9DW|XE 5GG|XE1X 7XA|XE1X 7XF|XE1 8NH|XE1 1RJ|XE1 1RN|XE1 1LE|XE24 99X|XE 0AA|XE12 8HJ)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}))$/i,
  sortCode: /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/,
  accountNumber: /^[0-9]{8}/,
  name: /^([a-zA-Z][-' ]{0,1})+[a-zA-Z]$/g,
  decimal: /[^\d\.]*/g,
  password:
    /^((?=.*\d)(?=.*[a-zA-Z])(?=.*[\'\!\"\$\%\^\&\*\(\)\_\\\-\/\+\=\{\}\[\]\@\‘\~\#\?\|<>,\.\;\:])[a-zA-Z\d\¬\'\!\"\$\%\^\&\*\(\)\_\\\-\/\+\=\{\}\[\]\@\~\#\?\|<>\,\.\;\:]{8,16})$/,
  username: /^[a-zA-Z0-9_.@!#$%&'*=+-]{6,16}$/,
  ntbUserName: /^(?![\d]{10}$)([a-zA-Z0-9_.@!#$%&'*=+-]{6,70})$/,
  linkCode: /^[0-9]{6,6}$/,
  numberWithDecimal: /^\d+$|^\d+\.$|^\d+\.\d{0,2}$/,
  accountName: /^([a-zA-Z][-' ]{0,1})+$/,
  moneyFormatter: /\B(?=(\d{3})+(?!\d))/g
};
/* eslint-enable no-useless-escape */

/*
format the post code with space if user enteres it with/without space
*/
const formatPostCode = (postCode) => {
  const postcodeMatch = postCode.toUpperCase().match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
  return postcodeMatch !== null ? postcodeMatch.shift().join(' ') : postCode;
};

export const isValidEmail = (value) =>
  value && !regexes.email.test(value)
    ? 'Hmm. Can you double check your email address? There might be a typo in there somewhere.'
    : undefined;

/**
 *  get the regex format from the regex list and check against the value to validate
 * @param {string} value
 * @param {string} type
 */
export const isValid = (value, type) =>
  regexes[type].test(type === 'PostCode' ? formatPostCode(value) : value);

export const formatMoneyInput = (amount) =>
  Math.abs(amount).toString().replace(regexes.moneyFormatter, ',');

export const formatMoneyInputWithPence = (amount) =>
  (Math.abs(amount) / 100).toFixed(2).toString().replace(regexes.moneyFormatter, ',');
